
import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardActions, CardContent, Divider, Grid, List, ListItem, ListItemText, MenuItem, TextField, Typography } from '@mui/material';
import { LayoutDashboard } from '../layouts/DasboardLayout';
import { useAuthentication } from '../hooks/useAuthentication';
import { API_URL } from '../config';
import { useFormik } from 'formik';
import toast from 'react-hot-toast';
import MensajeDialog from '../components/Dialogs/MensajeDialog';
import * as Yup from 'yup';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ScrollbarContainer from '../components/ScrollBar/CustomScrollbar';

const initialValues = {
  //Datos de signos vitales
  motivo: '',
  especialidad: '',
  observaciones: '',
};

const validationSchema = Yup.object().shape({
  motivo: Yup.string(),
  especialidad: Yup.string().required('Este campo es requerido'),
  observaciones: Yup.string(),
});

const Page = () => {
  const { idUser } = useAuthentication();
  const isXs = window.innerWidth < 600;
  const [formSend, setFormSend] = useState(false);
  const [dataResponse, setDataResponse] = useState(null);
  const [registroEcontrado, setRegistroEncontrado] = useState(false);
  const [especialidades, setEspecialidades] = useState([]);
  const [startWithForm, setStartWithForm] = useState(false);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      values.user = idUser;
      const newData = {
        id: dataResponse._id,
        folio: dataResponse.folio,
        estatus: 'Finalizado Triage',
        data: {
          motivo: values.motivo,
          especialidad: values.especialidad,
          observaciones: values.observaciones,
        },
      };
      try {
        const response = await fetch(`${API_URL}/person/consulta/update`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify(newData),
          }
        );
        if (!response.ok) {
          const errorData = await response.json();
          toast.error(errorData.message);
          return;
        }

        toast.success('Registro guardado correctamente');
        //Recargar la pagina
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } catch (error) {
        console.error(error);
        toast.error('Error al guardar el registro');
      }
    }
  });

  const getByFolio = async (folio) => {
    try {
      const response = await fetch(`${API_URL}/person/consulta/${folio}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        const errorData = await response.json();
        toast.error(errorData.message);
        return;
      }
      formik.setValues(data);
      setRegistroEncontrado(true);
      setDataResponse(data);
    } catch (error) {
      console.error(error);
      toast.error('Error al buscar el registro');
    }
  }

  const handleStartWithForm = async () => {
    try {
      const response = await fetch(`${API_URL}/person/consulta/update`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify({
            id: dataResponse._id,
            estatus: 'En Proceso Triage'
          }),
        }
      );
      //const data = await response.json();
      if (!response.ok) {
        const errorData = await response.json();
        toast.error(errorData.message);
        return;
      }
      toast.success('Registro actualizado correctamente');
      setStartWithForm(true);

      //Recargar la pagina despues de 2 segundos

    } catch (error) {
      console.error(error);
      toast.error('Error al buscar el registro');
    }
  }

  const getEspecialidades = async () => {
    try {
      const response = await fetch(`${API_URL}/especialidad/active`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.json();
      setEspecialidades(data);
    }
    catch (error) {
      toast.error('Error al obtener las especialidades');
      console.error(error);
    }
  }

  const [configuracion, setConfiguracion] = useState(null);
  const getConfiguracion = async () => {
    try {
      const response = await fetch(
        `${API_URL}/configuracion/info`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      const data = await response.json();
      if (response.ok) {
        setConfiguracion(data);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error fetching configuracion:', error);
      toast.error('Error al obtener la configuración');
    }
  };

  useEffect(() => {
    getEspecialidades();
    getConfiguracion();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        p: 5,
      }}
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={12}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: isXs ? 'column' : 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              height: '100%',
              width: '100%',
            }}
          >
            <Typography
              variant="h4"
              align="center"
              color="textPrimary"
              gutterBottom
              fontWeight={700}
            >
              Triage
            </Typography>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <TextField
                required
                label="Turno"
                name="turno"
                value={formik.values.turno}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.turno && Boolean(formik.errors.turno)}
                helperText={formik.touched.turno && formik.errors.turno}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  width: '100%',
                  maxWidth: '300px',
                  backgroundColor: 'white',
                }}
              />
              <Button
                color="primary"
                variant="contained"
                sx={{
                  marginLeft: 2,
                }}
                onClick={() => getByFolio(formik.values.turno)}
              >
                Buscar
              </Button>
            </Box>
          </Box>
        </Grid>

        {dataResponse && (
          <Grid
            item
            xs={12}
            md={dataResponse ? 4 : 12}
          >
            <Accordion
              defaultExpanded
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography
                  component="span"
                  variant="subtitle1"
                  color="primary"
                  fontWeight={700}
                >
                  Datos del paciente
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <List>
                  <ListItem>
                    <ListItemText
                      primary={'Folio'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.folio}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Nombre'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.nombre}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Dirección'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.direccion}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Teléfono'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.telefono}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Fecha de nacimiento'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={new Date(dataResponse?.fechaNacimiento).toLocaleDateString()}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Edad'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.edad}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'CURP'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.curp}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Municipio'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.municipio}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Sexo'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.sexo}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Estatus'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.estatus}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Fecha de creación'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={new Date(dataResponse?.updatedAt).toLocaleDateString()}
                    />
                  </ListItem>
                </List>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography
                  component="span"
                  variant="subtitle1"
                  color="primary"
                  fontWeight={700}
                >
                  Expediente
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  padding: 0,
                }}
              >
                <List
                  sx={{
                    width: '100%',
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <ListItem>
                    <ListItemText
                      primary={'Peso'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].peso}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Talla'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].talla}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Frecuencia Cardiaca'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].frecuenciaCardiaca}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Frecuencia Respiratoria'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].frecuenciaRespiratoria}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Presión Arterial'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={`${dataResponse?.consultas[0].presionArterialUno}/${dataResponse?.consultas[0].presionArterialDos}`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Temperatura'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].temperatura}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Saturación de CO2'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].saturacionCo2}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Perímetro Abdominal'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].perimetroAbdominal}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Glucosa'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={dataResponse?.consultas[0].glucosa}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={'Fecha de creación'}
                      primaryTypographyProps={{
                        fontWeight: 700,
                      }}
                      secondary={new Date(dataResponse?.updatedAt).toLocaleDateString()}
                    />
                  </ListItem>
                </List>
              </AccordionDetails>
            </Accordion>
          </Grid>
        )}
        {registroEcontrado && (
          <Grid
            item
            xs={12}
            md={dataResponse ? 8 : 12}
          >
            <Card
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                flexDirection: 'column',
                borderRadius: '20px',
                padding: 2,
              }}
            >
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      color="textPrimary"
                    >
                      Nombre del paciente:  {" "} <strong>{dataResponse?.nombre ?? ''}</strong>
                    </Typography>
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                      width: '100%',
                    }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={handleStartWithForm}
                    >
                      Comenzar registro
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Card>

            {startWithForm && (
              <Card
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  flexDirection: 'column',
                  borderRadius: '20px',
                  marginTop: 5,
                }}
              >
                <CardContent
                  sx={{
                    width: '100%',
                  }}
                >
                  <ScrollbarContainer>
                    <Typography
                      variant="h4"
                      align="center"
                      color="textPrimary"
                      gutterBottom
                      fontWeight={700}
                    >
                      Formulario de Registro {configuracion?.nombre || ''}
                    </Typography>
                    <Typography
                      variant="body1"
                      color="textPrimary"
                      gutterBottom
                    >
                      Formulario de Triage para asignación de pacientes a especialidades
                    </Typography>
                    <Divider sx={{ mt: 2, mb: 2 }} />
                    <Grid
                      container
                      spacing={2}
                    >
                      <Grid
                        item
                        xs={12}
                        md={12}
                      >
                        <TextField
                          required
                          label="Especialidad"
                          name="especialidad"
                          value={formik.values.especialidad}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.especialidad && Boolean(formik.errors.especialidad)}
                          helperText={formik.touched.especialidad && formik.errors.especialidad}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                          select
                        >
                          {
                            especialidades.map((especialidad) => (
                              <MenuItem key={especialidad.id} value={especialidad.id}>
                                {especialidad.nombre}
                              </MenuItem>
                            ))
                          }
                        </TextField>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                      >
                        <TextField
                          required
                          multiline
                          rows={4}
                          label="Motivo de consulta"
                          name="motivo"
                          value={formik.values.motivo}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.motivo && Boolean(formik.errors.motivo)}
                          helperText={formik.touched.motivo && formik.errors.motivo}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                      >
                        <TextField
                          required
                          multiline
                          rows={4}
                          label="Observaciones"
                          name="observaciones"
                          value={formik.values.observaciones}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.observaciones && Boolean(formik.errors.observaciones)}
                          helperText={formik.touched.observaciones && formik.errors.observaciones}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          sx={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                    </Grid>
                  </ScrollbarContainer>
                </CardContent>
                <CardActions
                  sx={{
                    display: 'flex',
                    justifyContent: 'right',
                    width: '100%',
                    padding: 2,
                  }}
                >
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={formik.resetForm}
                  >
                    Limpiar
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={formik.handleSubmit}
                  >
                    Guardar
                  </Button>
                </CardActions>
              </Card>
            )}
          </Grid>

        )}

        <Grid
          item
          xs={12}
          md={12}
        >
          <Grid
            container
            spacing={1}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              width: '100%',
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
            >
              <Typography
                variant="h6"
                color="textPrimary"
              >
                Fichas disponibles por especialidad:
              </Typography>
            </Grid>
            {
              especialidades?.length > 0 && especialidades?.map((especialidad) => (
                <Grid
                  item
                  xs={6}
                  md={1.5}
                  key={especialidad.id}
                >
                  <Card
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <Typography
                      align="center"
                      color="textPrimary"
                      fontWeight={700}
                      sx={{
                        fontSize: 14,
                      }}
                    >
                      {especialidad.nombre}
                    </Typography>
                    <Typography
                      align="center"
                      color="textPrimary"
                      sx={{
                        fontSize: 18
                      }}
                    >
                      {especialidad.consultas}
                    </Typography>
                  </Card>
                </Grid>
              ))
            }
          </Grid>
        </Grid>
      </Grid>

      <MensajeDialog
        open={formSend}
        data={dataResponse}
        handleClose={() => setFormSend(false)}
      />
    </Box>
  );
};

const Triage = () => {
  return (
    <LayoutDashboard>
      <Page />
    </LayoutDashboard>
  );
}

export default Triage;
